import "../scss/ebookactivecampaign.scss";

import $ from "jquery"

$('.js-ebook-activecampaign-open').each(function(){
    $(this).on('click', function(){
        $(this).closest('.section--ebook-activecampaign').find('.js-ebook-activecampaign-modal').addClass('ebook-activecampaign__modal--active');
    });
});

$('.js-ebook-activecampaign-close').each(function(){
    $(this).on('click', function(){
        $(this).closest('.section--ebook-activecampaign').find('.js-ebook-activecampaign-modal').removeClass('ebook-activecampaign__modal--active');
    });
});

/**
 * Cloning input data from contact form to active campaign form
 */
$(document).on('mouseup', function(e) {
    var container = $(".js-ebook-activecampaign-modal");
    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
        $('.js-ebook-activecampaign-modal').removeClass('ebook-activecampaign__modal--active');
    }
});

document.addEventListener('wpcf7mailsent', function(event) {
    if ( 'Ebook Sent' == event.detail.apiResponse.message) {
        $('.js-ebook-form').addClass('hide');
        $('.js-ebook-thank-you').addClass('show');
    }
}, false);
